import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAppDirective]'
})
export class AppDirectiveDirective {

  constructor() { }

}



@Directive({
  selector: '[appNumberOnly]'
})
export class NumberOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}


@Directive({
  selector: '[appCharacterOnly]'
})
export class CharacterOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/[^a-zA-Z_]*/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}

@Directive({
  selector: '[policyNumberOnly]'
})
export class PolicyNumberOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    // this._el.nativeElement.value = initalValue.replace(/^[a-z0-9_\-]+$/, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    var key = event.shiftKey || event.keyCode || 0;
    const initalValue = this._el.nativeElement.value;
    if (key !== 8 && key !== 9) {
      if (initalValue.length === 1) {
        if (initalValue.toUpperCase() == "G") {

        } else {
          this._el.nativeElement.value = "";
        }
      }

      switch (initalValue.toUpperCase()) {

        case "GHI":
          if (initalValue.length === 3) {
            this._el.nativeElement.value = initalValue + "-";
          } else {
            this._el.nativeElement.value = "";
          }
          break;

        case "GCI":
          if (initalValue.length === 3) {
            this._el.nativeElement.value = initalValue + "-";
          } else {
            this._el.nativeElement.value = "";
          }
          break;

        case "GFB":
          if (initalValue.length === 3) {
            this._el.nativeElement.value = initalValue + "-";
          } else {
            this._el.nativeElement.value = "";
          }
          break;
        // case "GP20":
        //     if(initalValue.length === 4){
        //       this._el.nativeElement.value = initalValue + "-";
        //     }else{
        //       this._el.nativeElement.value = "";
        //     }
        // break; 
        case "GP":
          if (initalValue.length === 2) {

            this._el.nativeElement.value = initalValue + "-";
          } else {
            this._el.nativeElement.value = "";
          }
          break;

        default:
          break;
      }
      if (initalValue.toUpperCase().startsWith('GP') && initalValue.length === 5) {
        this._el.nativeElement.value = initalValue + "-";
      } else if ((initalValue.toUpperCase().startsWith('GHI') || initalValue.toUpperCase().startsWith('GFB') || initalValue.toUpperCase().startsWith('GCI')) && initalValue.length === 6) {
        this._el.nativeElement.value = initalValue + "-";
      } else if (initalValue.toUpperCase().startsWith('GP') && initalValue.length === 8) {
        this._el.nativeElement.value = initalValue + "-";
      } else if ((initalValue.toUpperCase().startsWith('GHI') || initalValue.toUpperCase().startsWith('GFB') || initalValue.toUpperCase().startsWith('GCI')) && initalValue.length === 9) {
        this._el.nativeElement.value = initalValue + "-";
      } else if (initalValue.toUpperCase().startsWith('GP') && initalValue.length > 20) {
        this._el.nativeElement.value = initalValue.slice(0, -1);
      } else if ((initalValue.toUpperCase().startsWith('GHI') || initalValue.toUpperCase().startsWith('GFB') || initalValue.toUpperCase().startsWith('GCI')) && initalValue.length > 20) {
        this._el.nativeElement.value = initalValue.slice(0, -1);
      }
      // else if(initalValue.toUpperCase().startsWith('GP20') && initalValue.length > 12){
      //   this._el.nativeElement.value = initalValue.slice(0,-1);
      // }
    }
  }
}


@Directive({
  selector: '[dateOfBirthOnly]'
})
export class dateOfBirthOnlyDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    for (var clean = initalValue.toString().replace(/[^0-9]+/g, ""), i = 0; i < clean.length; i++) {
      if (2 == i)
        this._el.nativeElement.value = clean[0] + "" + clean[1] + "/" + clean.substr(2);
      if (6 == i)
        this._el.nativeElement.value = this._el.nativeElement.value.substr(0, 5) + "/" + this._el.nativeElement.value.substr(5);;
    }


  }
  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const initalValue = this._el.nativeElement.value;
    var code = event.keyCode || event.which;
    101 !== code && 32 !== code && 109 !== code && 45 !== code || event.preventDefault()
  }


}